var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAjaxLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 94,
    viewBox: "0 0 100 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3856 2.99738C12.4889 9.20609 5.85298 18.14 2.47918 28.451C-0.894614 38.762 -0.823227 49.8905 2.68257 60.1574C6.18837 70.4242 12.9384 79.2723 21.9139 85.3663C30.8895 91.4604 41.6037 94.4698 52.4397 93.9404C63.2757 93.4111 73.6455 89.3717 81.9844 82.4318C90.3232 75.4919 96.1786 66.028 98.667 55.4683C101.155 44.9087 100.142 33.8261 95.7789 23.8931C91.4162 13.96 83.9411 5.71549 74.4816 0.403527L67.01 13.7088C73.5825 17.3996 78.7763 23.128 81.8076 30.0295C84.8389 36.9311 85.5432 44.6313 83.8142 51.9683C82.0853 59.3052 78.0169 65.8808 72.223 70.7027C66.4291 75.5246 59.2241 78.3312 51.6951 78.699C44.1662 79.0668 36.7219 76.9759 30.4856 72.7417C24.2493 68.5075 19.5593 62.3598 17.1234 55.2263C14.6876 48.0928 14.638 40.3606 16.9821 33.1964C19.3263 26.0323 23.937 19.8249 30.1185 15.511L21.3856 2.99738Z",
    fill: "url(#paint0_linear_1454_4525)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1454_4525",
    x1: 28.5,
    y1: -2.5,
    x2: 108,
    y2: 103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8252C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930464,
    stopColor: "#4A316B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjaxLoader);
export default __webpack_public_path__ + "static/media/ajax-loader.cdebb7affebd036b5195239b5ba6ecf8.svg";
export { ForwardRef as ReactComponent };